module.exports = __webpack_public_path__ + "img/homepage-quick-links-toyota.5fd42f1c.jpg";